$(document).ready(function() {
  const pageClass = ".customer-health-bulk-csv-exports";
  const container = `${pageClass} #application_ids`;

  $(pageClass).on("click", ".btn.select-all", function(event) {
    $(`${container} option`).prop("selected", true);
    $(container).trigger("chosen:updated");
  });

  $(pageClass).on("click", ".btn.deselect-all", function(event) {
    $(`${container} option:selected`).prop("selected", false);
    $(container).trigger("chosen:updated");
  });
});